import { render, staticRenderFns } from "./FiltroTags.vue?vue&type=template&id=3ea2fb6f"
import script from "./FiltroTags.vue?vue&type=script&lang=js"
export * from "./FiltroTags.vue?vue&type=script&lang=js"
import style0 from "./FiltroTags.vue?vue&type=style&index=0&id=3ea2fb6f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports